<template>
	<section id="kunden" class="w-100 bg-white">
		<b-row v-view="viewHandler">
			<b-col cols="12" lg="6" offset-lg="3" class="text-center px-3 px-lg-5 pt-3 viewer fade">
				<h3 class="pb-3 ">
					<span v-if="$creo.getLang() == 'sv'">Omvärlden påverkar <br> kundens behov och önskemål</span>
					<span v-else>External factors affect the customer’s needs and wishes</span>

				</h3>
			</b-col>
		</b-row>
		<b-row v-view="viewHandler" class="d-flex justify-content-center">
			<b-col cols="10" lg="7"  class="pb-2 pt-2 text-center viewer fade">
				<p class="m-0 elh">
					<span v-if="$creo.getLang() == 'sv'">Genom välgrundade kundinsikter får vi god kännedom om våra kunders behov och preferenser, som är vägledande för oss i utvecklingen av bostäder och bostadsområden.</span>
					<span v-else>Through solid customer insights, we gain good knowledge about our customers’ needs and preferences, which guides us in our development of residential units and residential areas.</span>
				</p>
			</b-col>
		</b-row>
		<b-row v-view="viewHandler" class="pb-lg-4">
			<b-col cols="12" lg="10" xl="10" offset-lg="1" offset-xl="1" class="pt-4 viewer fade">
				<b-row class="d-flex justify-content-center px-3 px-lg-0">
					<b-col cols="12" lg="4"  class="text-center pt-3 pt-lg-5 d-flex justify-content-center" order="0" order-lg="0">
						<a 	:href="$creo.browserPdfLink(pdfLink.utveckling.org[$creo.getLang()], pdfLink.utveckling.fallback[$creo.getLang()], pdfLink.utveckling.page[$creo.getLang()])" target="_blank" class="text-decoration-none text-black">
							<div class="img-hover-zoom2 img-kunden">
								<b-img src="../assets/img/kund1.jpg" class="img-kunden"/>
							</div>
							<p class=" pt-3">
								<span v-if="$creo.getLang() == 'sv'">Produktutveckling<br> och nytänkande</span>
								<span v-else>Product development and <br>innovative thinking</span>

							</p>
						</a>
					</b-col>
					<b-col cols="12" lg="4" class="text-center pt-5  d-flex justify-content-center" order="2" order-lg="1">
						<a 	:href="$creo.browserPdfLink(pdfLink.nyproduktion.org[$creo.getLang()], pdfLink.nyproduktion.fallback[$creo.getLang()], pdfLink.nyproduktion.page[$creo.getLang()])" target="_blank" class="text-decoration-none text-black ">
							<div class="img-hover-zoom2 img-kunden">
								<b-img src="../assets/img/kund2.jpg" class="img-kunden"/>
							</div>
							<p class=" pt-3">
								<span v-if="$creo.getLang() == 'sv'">Fem skäl att välja<br> nyproduktion från JM</span>
								<span v-else>Five reasons to choose <br>a newly built home from JM</span>

							</p>
						</a>
					</b-col>
					<b-col cols="12" lg="4" class="text-center pt-5  d-flex justify-content-center" order="4" order-lg="2">
						<a 	:href="$creo.browserPdfLink(pdfLink.focus.org[$creo.getLang()], pdfLink.focus.fallback[$creo.getLang()], pdfLink.focus.page[$creo.getLang()])" target="_blank" class="text-decoration-none text-black">
							<div class="img-hover-zoom2 img-kunden">
								<b-img src="../assets/img/kund3.jpg" class="img-kunden"/>
							</div>
							<p class="px-5 pt-3">
								<span v-if="$creo.getLang() == 'sv'">Med människan<br> i fokus</span>
								<span v-else>Focus on people</span>

							</p>
						</a>
					</b-col>
					<b-col cols="12" lg="4"  class="text-center pt-0 pt-lg-2 ml-auto d-none d-lg-flex justify-content-center" order="1" order-lg="3">
						<a 	:href="$creo.browserPdfLink(pdfLink.utveckling.org[$creo.getLang()], pdfLink.utveckling.fallback[$creo.getLang()], pdfLink.utveckling.page[$creo.getLang()])"
							target="_blank"
							class="btn btn-link pt-3 italic text-decoration-none standard-white">
							<span v-if="$creo.getLang() == 'sv'">Läs mer</span>
							<span v-else>Read more</span><span class="ml-2 arrow-gray float-right"></span>
						</a>
					</b-col>
					<b-col cols="12" lg="4" class="text-center pt-0 pt-lg-2 d-none d-lg-flex justify-content-center" order="3" order-lg="4">
						<a 	:href="$creo.browserPdfLink(pdfLink.nyproduktion.org[$creo.getLang()], pdfLink.nyproduktion.fallback[$creo.getLang()], pdfLink.nyproduktion.page[$creo.getLang()])"
							target="_blank"
							class="btn btn-link pt-3 italic text-decoration-none standard-white">
							<span v-if="$creo.getLang() == 'sv'">Läs mer</span>
							<span v-else>Read more</span><span class="ml-2 arrow-gray float-right"></span>
						</a>
					</b-col>
					<b-col cols="12" lg="4" class="text-center pt-2 mr-auto justify-content-center" order="5" order-lg="5">
						<a 	:href="$creo.browserPdfLink(pdfLink.focus.org[$creo.getLang()], pdfLink.focus.fallback[$creo.getLang()], pdfLink.focus.page[$creo.getLang()])"
							target="_blank"
							class="btn btn-link pt-3 italic text-decoration-none standard-white">
							<span v-if="$creo.getLang() == 'sv'">Läs mer</span>
							<span v-else>Read more</span><span class="ml-2 arrow-gray float-right"></span>
						</a>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
	</section>
</template>
<script>
	import CModal from '@/components/Modal.vue'
	export default {
		props: {
			pdfLink: Object
		},
		data() {
			return {
				openId: 0
			}
		},
		components: {
			CModal
		},
		methods: {
			viewHandler(e) {
				// console.log(e)
			}
		}
	}
</script>
